import {imageMapping} from './imageMapping';
import {RECEIVABLE_ORDER, RECEIVABLE_TYPES} from './receivableTypes';

/**
 * Sorts the payment methods and return the ordered set of icon names
 * @param {array} methods Array of receivable methods with `receivablePaymentMethod` and `ccType`
 * @returns a sorted set of payment icon names
 */
const getPaymentIcons = (methods) => {
  const images = methods
    ?.map((method) => {
      const {receivablePaymentMethod, ccType} = method || {};
      const description = ccType?.replace(' ', '');

      return receivablePaymentMethod?.toLowerCase() === RECEIVABLE_TYPES.CREDIT_CARD
        ? description
        : receivablePaymentMethod;
    })
    .filter((method) => RECEIVABLE_ORDER[method] !== undefined)
    .sort((method1, method2) => RECEIVABLE_ORDER[method1] - RECEIVABLE_ORDER[method2])
    .map((method) => imageMapping[method])
    .filter((method) => !!method);

  return [...new Set(images)];
};

export {getPaymentIcons};
